import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLogOut, lucideUser } from '@ng-icons/lucide';

import { ChangePasswordFormComponent } from '../../components/change-password-form/change-password-form.component';
import { UI } from '../../components/ui';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-change-password-page',
  standalone: true,
  imports: [ChangePasswordFormComponent, NgIcon, ...UI],
  providers: [provideIcons({ lucideUser, lucideLogOut })],
  templateUrl: './change-password-page.component.html',
})
export class ChangePasswordPageComponent {
  private readonly router = inject(Router);
  readonly auth = inject(AuthService);

  readonly displayName = computed(() => {
    const user = this.auth.user();
    if (!user) return 'User';
    const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
    if (fullName) return fullName;
    if (user.username) return user.username;
    return 'User';
  });

  readonly roleLabel = computed(() => {
    const active = this.auth.user()?.active_assignment;
    if (!active?.role_code) return null;
    return active.merchant_name ? `${active.role_code} - ${active.merchant_name}` : active.role_code;
  });

  readonly mode = computed<'required' | 'recovery'>(() =>
    this.auth.user()?.password_recovery_session ? 'recovery' : 'required',
  );

  onPasswordChanged(): void {
    this.router.navigate(['/app']);
  }

  handleLogout(): void {
    this.auth.logout();
  }
}
